import React from 'react';
import MinorCategories from '../../minorcategories';

export default class HeaderPanelBottom extends React.Component {
  static propTypes = {
    panels: React.PropTypes.object.isRequired
  };

  render () {
    var content = '';
    if (this.props.panels.bot === 'category') {
      content = <MinorCategories {...this.props} />;
    }
    return (
      <div className="header__panel--bottom">
        {content}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/panels/bottom/index.js